import React, { FC, useState } from "react"
import { Button } from "@mui/material"
import { useAppDispatch } from "../../../redux/hooks"
import { sendForgotPasswordEmailAsync } from "../../../redux/slices/authSlice"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import AppInput from "../../AppInput/AppInput.component"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import likeIcon from "../../../assets/images/like.png"
import {
  emailFormInitialValues,
  useValidationSchemas,
} from "../../../hooks/useIsValidationScehemes"
import { useBranding } from "../../../hooks/useBranding";
import { useIsGoTo } from "../../../hooks/useIsGoTo";
import "./ForgotPasswordModal.scss"
type ForgotPasswordModalProps = {
  open: boolean
  handleClose: () => void
}

const ForgotPasswordModal: FC<ForgotPasswordModalProps> = ({
  open,
  handleClose,
}) => {
  const {
    INPUT_EMAIL,
    FORGOT_PASSWORD_MODAL_TITLE,
    FORGOT_PASSWORD_MODAL_DESCRIPTION,
    BTN_SUBMIT,
    FORGOT_PASSWORD_SUCCESS_MODAL_TITLE,
    FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_1,
    FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_2,
  } = useTranslationLabel()
  const { logo } = useBranding();
  const { name } = useIsGoTo();
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { emailSchema } = useValidationSchemas()
  const {
    formData,
    errors,
    handleChange,
    validateField,
    validateForm,
    isValidIsraeliID,
    isValidEmail,
  } = useFormValidation(emailFormInitialValues, emailSchema)
  
  const handleForgotPasswordSubmit = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault()
    setLoading(true)

    if (!validateForm()) {
      setLoading(false)
      return
    }

    try {
      const email = formData.email
      const response = await dispatch(
        sendForgotPasswordEmailAsync({ email }),
      ).unwrap()
      if (response) {
        dispatch(
          showModal({
            activeModal: ModalTypes.SIMPLE_MODAL,
            data: {
              title: FORGOT_PASSWORD_SUCCESS_MODAL_TITLE,
              description: FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_1,
              description2: FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_2,
              image: likeIcon,
            },
          }),
        )
      }
    } catch (error) {
      alert("There was an error!")
    }

    setLoading(false)
  }


  return (
    <GenericModal
      title={FORGOT_PASSWORD_MODAL_TITLE}
      description={FORGOT_PASSWORD_MODAL_DESCRIPTION}
      image={logo}
      className={`forgot-password-modal-${name}`}
      open={open}
      loading={loading}
      handleClose={handleClose}
    >
      <form
        onSubmit={handleForgotPasswordSubmit}
        className="form-container column"
      >
        <AppInput
          label={INPUT_EMAIL}
          name="email"
          value={formData.email}
          className="email"
          error={errors.email}
          onChange={handleChange}
        />

        <Button
          type="submit"
          disabled={!isValidEmail(formData.email) && !isValidIsraeliID(formData.email)}
          variant="contained"
          className="primary-btn"
        >
          {BTN_SUBMIT}
        </Button>
      </form>
    </GenericModal>
  )
}

export default ForgotPasswordModal
